import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * DccFormEdit - Page wrapper for editing filled DCC forms
 * Used for navigation in routes/index.tsx
 */
const DccFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default DccFormEdit;
